<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 21"
    fill="none"
    :height="height"
    :width="width"
  >
    <path
      d="M10 15.7167C10.4081 15.7167 10.7389 15.3859 10.7389 14.9778C10.7389 14.5697 10.4081
        14.2389 10 14.2389C9.59192 14.2389 9.26111 14.5697 9.26111 14.9778C9.26111 15.3859
        9.59192 15.7167 10 15.7167Z"
      :fill="color"
    />
    <path
      d="M10 13.0611C9.85267 13.0611 9.71136 13.0026 9.60718 12.8984C9.50299 12.7942 9.44446
        12.6529 9.44446 12.5055V5.83888C9.44446 5.69154 9.50299 5.55023 9.60718
        5.44604C9.71136 5.34186 9.85267 5.28333 10 5.28333C10.1474 5.28333 10.2887 5.34186 10.3929
        5.44604C10.497 5.55023 10.5556 5.69154 10.5556 5.83888V12.5055C10.5556 12.6529 10.497
        12.7942 10.3929 12.8984C10.2887 13.0026 10.1474 13.0611 10 13.0611Z"
      :fill="color"
    />
    <path
      d="M8.36779 1.43391C8.5222 1.15289 8.74928 0.918513 9.02528 0.755305C9.30129 0.592098 9.61608
        0.506051 9.93673 0.506165C10.2574 0.506278 10.5721 0.592548 10.848 0.755951C11.1239
        0.919354 11.3508 1.15389 11.505 1.43502L19.2217 15.635C19.3697 15.9075 19.4443 16.2137
        19.4383 16.5237C19.4323 16.8337 19.3458 17.1368 19.1873 17.4033C19.0288 17.6698 18.8038
        17.8905 18.5343 18.0438C18.2648 18.1971 17.9601 18.2778 17.65 18.2778H2.23446C1.92092
        18.2848 1.61104 18.2093 1.3359 18.0588C1.06076 17.9083 0.830027 17.688 0.66683
        17.4202C0.503633 17.1524 0.41371 16.8464 0.406078 16.5329C0.398446 16.2194 0.473372 15.9093
        0.623344 15.6339L8.36779 1.43391ZM1.60001 16.1656C1.54277 16.2708 1.51444 16.3893 1.51791
        16.5091C1.52138 16.6288 1.55652 16.7455 1.61976 16.8472C1.68299 16.949 1.77206 17.0321
        1.87789 17.0882C1.98372 17.1444 2.10254 17.1714 2.22223 17.1667H17.65C17.7675 17.1666
        17.8829 17.136 17.985 17.0779C18.0871 17.0197 18.1724 16.9361 18.2324 16.8351C18.2924
        16.734 18.3251 16.6192 18.3273 16.5017C18.3295 16.3842 18.3012 16.2682 18.245 16.165L10.53
        1.9678C10.4715 1.86156 10.3856 1.77296 10.2812 1.71124C10.1769 1.64951 10.0578 1.61692
        9.93656 1.61686C9.8153 1.61681 9.69624 1.64929 9.5918 1.71091C9.48736 1.77254 9.40137
        1.86106 9.34279 1.96724L1.59946 16.1656H1.60001Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'CgIconWarning',
  props: {
    width: {
      type: [Number, String],
      required: false,
      default: 20,
    },
    height: {
      type: [Number, String],
      required: false,
      default: 20,
    },
    color: {
      type: String,
      required: false,
      default: '#444444',
    },
  },
});
</script>
